import { Thread as StreamThread } from 'stream-chat-react'
import { ChatFooter } from '../ChatFooter'
import { useCallback } from 'react'

export const Thread = () => {
  const Input = useCallback(() => <ChatFooter threadList />, [])

  return (
    <StreamThread
      Input={Input}
    />
  )
}

export * from './components'
